export default __webpack_public_path__ + "d93b9e44c07d7319bab2984297dbe9db.png";